/* unplugin-vue-components disabled */import script from "./eExercise.vue?vue&type=script&setup=true&lang=js"
export * from "./eExercise.vue?vue&type=script&setup=true&lang=js"

import "./eExercise.vue?vue&type=style&index=0&id=fbd818e2&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbd818e2"]])

export default __exports__